module.exports = __webpack_public_path__ + "img/ic_save.598e221c.svg";